<template>
  <TarjetaDatos titulo="Historial" tipo="naranja">
    <div
      v-for="itemNotif in siniestro.notificaciones"
      :key="itemNotif.id"
      class="fila"
    >
      <div class="etiq fecha">
        {{ itemNotif.fecha | dateDDMMYYYYhhmm }}
      </div>
      <div class="texto">
        {{ itemNotif.texto }}

        <div v-for="itemDoc in itemNotif.documentos" :key="itemDoc.uuid">
          <a
            href="#"
            target="_blank"
            class="documento"
            @click.prevent="downloadDocumento(itemDoc.uuid)"
          >
            <fai :icon="['fas', 'download']" />
            {{ itemDoc.nombreDoc }}
            <br />
          </a>
        </div>
      </div>
    </div>
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    siniestro: {
      type: Object,
      required: true,
    },
  },
  methods: {
    downloadDocumento: async function (uuid) {
      this.$store.dispatch("dowloadDocumento", uuid);
    },
  },
};
</script>

<style lang="scss" scoped>
.fila {
  margin-bottom: 0.75rem;
  display: flex;
  flex-flow: row nowrap;
}

.nuevaFila {
  margin-bottom: 0.75rem;
  flex-flow: row nowrap;
  color: green;
}
.fecha {
  white-space: nowrap;
  margin-right: 1rem;
}
.texto {
  max-width: 40rem;
}
.documento {
  font-size: 80%;
  color: #0053a2;
}

@media screen and (max-width: 40em) {
  .fila {
    flex-flow: row wrap;
  }
}
</style>
